import Component from '@glimmer/component';
import { action } from '@ember/object';
import { on } from '@ember/modifier';
import { t } from 'ember-intl';
import { type SlChangeEvent, SlSelect } from '@shoelace-style/shoelace';
import type { School, InstitutionType } from 'dashboard/types';

interface SchoolDropdownSelectSignature {
  Element: SlSelect;
  Args: {
    schools: {
      id: string;
      district: string;
      name: string;
      type: InstitutionType;
      children?: School[];
    }[];
    onChange?(value: string): void;
  };
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    SchoolDropdownSelect: typeof SchoolDropdownSelect;
  }
}

export default class SchoolDropdownSelect extends Component<SchoolDropdownSelectSignature> {
  @action onChange(event: SlChangeEvent) {
    const target = event.target as SlSelect;
    const val = target?.value;
    this.args.onChange?.(typeof val === 'string' ? val : (val[0] as string));
  }

  <template>
    <sl-select
      label={{t 'Choose a school'}}
      placeholder={{t 'Choose a school'}}
      {{on 'sl-change' this.onChange}}
      size='medium'
      hoist
      required
      data-test-school-dropdown
      ...attributes
    >
      {{#each @schools as |school|}}
        <sl-option value='{{school.id}}'>
          {{school.name}}
        </sl-option>
      {{/each}}
    </sl-select>
  </template>
}
